import { z } from "zod"
import type { TUtcDateTime } from "../types"

/**
 * Parses an ISO UTC datetime string (trailing `Z` required, offsets rejected)
 * into the `TUtcDateTime` template type.
 *
 * This is the single place where a plain string may become a `TUtcDateTime`;
 * everywhere else the type should flow from this schema.
 */
export const utcDateTimeSchema = z.iso.datetime().transform((value) => value as TUtcDateTime)
